import { Offcanvas } from 'bootstrap'

// On back/forward, Turbo restores a cached snapshot. If an offcanvas was open, the
// snapshot brings back the open panel — but the Bootstrap instance that owned it is
// gone, so its fresh replacement thinks it's closed: the dismiss button no-ops and
// the orphaned backdrop blocks every click, freezing the page.
//
// Re-hydrate on restore: drop the orphaned backdrop + body scroll-lock, then re-show
// each open panel through a live instance so it comes back open AND interactive
// (closable) again. Per-offcanvas options (backdrop/scroll) must live in data-bs-*
// attributes so the re-created instance matches the original. Covers every offcanvas
// — Stimulus-driven or data-bs-toggle.
export function restoreOpenOffcanvas() {
  const panels = document.querySelectorAll('.offcanvas.show')
  if (panels.length === 0) return

  document.querySelectorAll('.offcanvas-backdrop').forEach((backdrop) => {
    backdrop.remove()
  })
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')

  panels.forEach((panel) => {
    Offcanvas.getOrCreateInstance(panel).show()
  })
}

document.addEventListener('turbo:load', restoreOpenOffcanvas)
